import {Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

import IconWarningTriangle from 'components/icons/warningTriangle.svg';

const SRoot = styled('div')(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.error.main,
  gap: theme.spacing(1),
}));

export function NothingFound() {
  return (
    <SRoot>
      <IconWarningTriangle color='error' fontSize='small' />
      <Typography variant='buttonSmall' color='error' noWrap>
        No Results
      </Typography>
    </SRoot>
  );
}
